<h1 mat-dialog-title>{{ data.title }}</h1>

<div mat-dialog-content>
  <app-dynamic-form
    [formFields]="data.currentState"
    (formSubmit)="formSubmit()"
  ></app-dynamic-form>
</div>

<div mat-dialog-actions align="end">
  <button mat-raised-button
          mat-dialog-close
          [disabled]="form.disabled">
    {{ 'BUTTONS.cancel' | translate }}
  </button>
  <button mat-raised-button
          type="submit"
          color="primary"
          (click)="formSubmit()"
          [disabled]="form.disabled"
          cdkMonitorElementFocus>
    {{ 'BUTTONS.save' | translate }}
  </button>
</div>
